import { useEffect, useRef, useState } from 'react';

export const useIsStuck = () => {
  const [isStuck, setIsStuck] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsStuck(entry.isIntersecting);
        setIsInitialized(true);
      },
      {
        threshold: 0,
      },
    );

    const currentElement = elementRef.current;
    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
      observer.disconnect();
    };
  }, []);

  return { elementRef, isStuck, isInitialized };
};
